import { render, staticRenderFns } from "./VectorLegend.vue?vue&type=template&id=3109a841&scoped=true"
import script from "./VectorLegend.vue?vue&type=script&lang=ts"
export * from "./VectorLegend.vue?vue&type=script&lang=ts"
import style0 from "./VectorLegend.vue?vue&type=style&index=0&id=3109a841&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3109a841",
  null
  
)

export default component.exports